import { createContext } from "react";

export interface SwitchableProps {
  dataType: "saunas" | "chairs";
}

export const SwitchableContext = createContext<SwitchableProps>({
  dataType: "saunas",
});
